import React, { Component } from "react";
import { connect } from "react-redux";

//ACTIONS
import * as ACTIONS from "./../../../actions/actionConstants";

//MUI
import { Switch, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    darkMode: state.app.darkMode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleToggle: (val, e) => {
      dispatch({
        type: ACTIONS.TOGGLE_DARK_MODE,
        payload: e
      });
    }
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class Settings extends Component {
  render() {
    const { classes, darkMode, handleToggle } = this.props;

    return (
      <div className={classes.root}>
        <Typography>client settings</Typography>
        <div style={{ paddingBottom: "2em" }}>
          <Switch
            checked={darkMode}
            onChange={handleToggle}
            aria-label="LoginSwitch"
          />
          dark mode
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Settings));



// WEBPACK FOOTER //
// ./src/pages/user_dashboard/account_tabs/Settings.js